/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowARightIcon20Regular = forwardRef('ArrowARightIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M11.188 3.968a.75.75 0 1 1 1.061-1.06l5.237 5.236a2.625 2.625 0 0 1 0 3.712l-5.237 5.237a.75.75 0 0 1-1.06-1.06l5.236-5.238c.015-.014.03-.03.043-.045H2.5a.75.75 0 0 1 0-1.5h13.968a1.15 1.15 0 0 0-.043-.045l-5.237-5.237Z" })));
});
